export const STOOL_SCORES = [
  { value: 1, label: '1 : Très dures et sèches', description: 'Très dures et sèches ; souvent expulsées sous forme de boulettes individuelles ; nécessitent beaucoup d\'effort ; ne laissent aucun résidu.' },
  { value: 2, label: '2 : Fermes mais pas dures (Idéal)', description: 'Fermes mais pas dures ; souples ; segmentées à l\'apparence ; peu ou pas de résidu. (Idéal)' },
  { value: 3, label: '3 : Forme de bûche, humide', description: 'En forme de bûche ; peu ou pas de segmentation visible ; surface humide ; laissent un résidu mais conservent leur forme.' },
  { value: 4, label: '4 : Très humides, détrempées', description: 'Très humides, détrempées ; en forme de bûche ; laissent un résidu et perdent leur forme.' },
  { value: 5, label: '5 : Très humides, forme distincte', description: 'Très humides mais avec une forme distincte ; s\'empilent plutôt que de former des bûches ; laissent un résidu et perdent leur forme.' },
  { value: 6, label: '6 : Texture sans forme définie', description: 'Ont une texture mais pas de forme définie ; se présentent sous forme de tas ou de taches ; laissent un résidu.' },
  { value: 7, label: '7 : Liquides', description: 'Liquides ; sans texture ; flaques plates.' },
];

export const STOOL_COLORS = [
  { value: 'brown', label: 'Marron (Normal)', color: '#8B4513' },
  { value: 'white_specks', label: 'Points blancs', color: '#D2B48C' },
  { value: 'mucus', label: 'Avec Mucus', color: '#cd853f' },
  { value: 'orange', label: 'Orange', color: '#ED9121' },
  { value: 'yellow_gray', label: 'Jaune ou Gris', color: '#DAA520' },
  { value: 'green', label: 'Vert', color: '#556b2f' },
  { value: 'shiny', label: 'Luisant / Gras', color: '#808080' },
  { value: 'pale', label: 'Pâle / Argile', color: '#D3D3D3' },
  { value: 'blue_green', label: 'Bleu / Vert', color: '#008080' },
  { value: 'pink_purple', label: 'Rose / Violet', color: '#800080' },
  { value: 'red_streaks', label: 'Traces de sang rouge', color: '#B22222' },
  { value: 'black', label: 'Noir / Marron très foncé', color: '#2F4F4F' },
];
